import { render, staticRenderFns } from "./fjlx.vue?vue&type=template&id=6117e660&scoped=true"
import script from "./fjlx.vue?vue&type=script&lang=js"
export * from "./fjlx.vue?vue&type=script&lang=js"
import style0 from "./fjlx.vue?vue&type=style&index=0&id=6117e660&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6117e660",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6117e660')) {
      api.createRecord('6117e660', component.options)
    } else {
      api.reload('6117e660', component.options)
    }
    module.hot.accept("./fjlx.vue?vue&type=template&id=6117e660&scoped=true", function () {
      api.rerender('6117e660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/fjlx.vue"
export default component.exports